/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import clsx from 'clsx';
import { useRouter } from 'next/router';
// import NextLink from "next/link";
import MuiLink from '@material-ui/core/Link';
import {
  Link as I18nLink,
  withTranslation,
  localeSubpaths,
  i18n,
} from 'config/i18n';

// Translate routes
const NextComposedWithI18n = withTranslation('routes')((props) => {
  const {
    as, href, t, anchorRef, translate = true, ...other
  } = props;

  let tHref = ''; // translated href
  const tHrefArr = []; // translated href array
  let path = as || href; // href without query strings
  let removedQuery; // Removed query strings

  // If href is extrenal, keep as it's & use MuiLink
  if (path && typeof path === 'string' && path.startsWith('http')) {
    return <MuiLink href={href} as={as} {...other} />;
  }
  if (path && typeof path === 'string') {
    if (path.indexOf('?') !== -1) {
      // Don't translate query strings if exist
      removedQuery = path.split('?')[1];
      path = path.split('?')[0];
    }
    path.split('/').forEach((segment) => {
      // Ignore if the segment is dynamic route like [id]
      if (!segment || segment.includes('javascript') || segment.includes('[') || !translate) {
        tHrefArr.push(segment); // Don't translate those segments
      } else {
        tHrefArr.push(t(`routes:${segment}`));
      }
    });
    tHref = tHrefArr.join('/') + (removedQuery ? `?${removedQuery}` : '');
  } else {
    tHref = as;
  }
  // To fix issue if page name is like localeSubpaths like /location-moto
  if (tHref == `/${localeSubpaths[i18n.language]}`) {
    // Add page name and localsubpath too it will be like location-moto/location-moto
    tHref += tHref;
  }

  return (
    <I18nLink href={href} as={tHref} prefetch={false}>
      <a ref={anchorRef} {...other} />
    </I18nLink>
  );
});

const NextComposed = React.forwardRef((props, ref) => (
  <NextComposedWithI18n {...props} anchorRef={ref} />
));

// A styled version of the Next.js Link component:
// https://nextjs.org/docs/#with-link
function Link(props) {
  const {
    href,
    activeClassName = 'active',
    className: classNameProps,
    innerRef,
    naked,
    ...other
  } = props;

  const router = useRouter();

  const pathname = typeof href === 'string' ? href : href.pathname;
  const className = clsx(classNameProps, {
    [activeClassName]: router.pathname === pathname && activeClassName,
  });

  if (naked) {
    return (
      <NextComposed
        className={className}
        ref={innerRef}
        href={href}
        {...other}
      />
    );
  }

  return (
    <MuiLink
      component={NextComposed}
      className={className}
      ref={innerRef}
      href={href}
      {...other}
    />
  );
}

export default React.forwardRef((props, ref) => (
  <Link {...props} innerRef={ref} />
));
